// extracted by mini-css-extract-plugin
export default {"container":"DocumentCompare_container__9V1uy","header":"DocumentCompare_header__bGMW6","button":"DocumentCompare_button__uzvKY"};